import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { PERMISSIONS } from '@/constants/permissions';
import { useUserStore } from '@/stores/userStore';

/** 成员管理代码加载时保留撑满内容区的布局，按权限预留邀请入口和启用状态列 */
export function MemberManagementSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canInvite = permissionCodes?.includes(PERMISSIONS['成员&权限/成员管理/邀请成员']);
  const canSwitchStatus = permissionCodes?.includes(PERMISSIONS['成员&权限/成员管理/启用状态切换']);

  return (
    <Card className="w-full h-full relative p-0" aria-hidden="true">
      <CardContent className="p-6 gap-4 flex flex-col relative h-full w-full">
        {/** 成员名称、邮箱、激活状态及重置入口 */}
        <div className="flex gap-4 flex-row items-center flex-wrap">
          <div className="relative w-full md:w-auto">
            <Skeleton className="h-9 w-full md:w-[200px]" />
          </div>
          <Skeleton className="h-9 w-full md:w-[200px]" />
          <Skeleton className="h-9 w-full md:w-[120px]" />
          <Skeleton className="h-9 w-16" />
          {/** 邀请与列配置入口沿用原排列和权限 */}
          <div className="flex flex-row-reverse items-center gap-2 shrink-0 flex-1">
            {canInvite && <Skeleton className="h-9 w-24" />}
            <Skeleton className="h-9 w-24" />
          </div>
        </div>

        {/** 表格区域占据剩余高度，启用状态列沿用原权限 */}
        <div className="flex-1 min-h-0">
          <ListPageSkeleton
            columnCount={canSwitchStatus ? 6 : 5}
            showPagination={false}
            filterArea={<></>}
            className="rounded-none border-0"
            contentClassName="gap-0 p-0"
          />
        </div>

        {/** 初始总数为零时仅显示记录总数，不预留翻页控件 */}
        <div className="shrink-0">
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-28" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
